var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{},[_vm._m(0),_c('div',{staticClass:"container content"},[_c('h2',[_vm._v("Frequently Asked Questions")]),_c('VueFaqAccordion',{staticClass:"faqs",attrs:{"items":_vm.faqs}})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("FAQs")])])])
}]

export { render, staticRenderFns }